<template>
  <div class="g-page">
    <!-- HEADER -->
    <div class="header-row">
      <h2 class="page-title">Paketlar</h2>
      <div class="header-actions">
        <div class="search-wrapper">
          <b-icon icon="search" class="search-icon"></b-icon>
          <input v-model="filter" type="search" :placeholder="$t('Qidiruv...')" class="modern-search">
        </div>

        <!-- Avtomobil Modeli filter -->
        <v-select
          class="header-vselect"
          :options="modelList"
          v-model="modelFilter"
          :reduce="m => m.id"
          label="name"
          :placeholder="$t('Avtomobil Modeli')"
          :clearable="true"
        >
          <template v-slot:no-options>
            <em style="opacity:.5">{{ $t("Bo'sh") }}</em>
          </template>
        </v-select>

        <!-- Paket turi filter -->
        <v-select
          class="header-vselect"
          :options="packageTypes"
          v-model="packageTypeFilter"
          :reduce="t => t.id"
          label="name"
          :placeholder="$t('Paket turi')"
          :clearable="true"
        >
          <template v-slot:no-options>
            <em style="opacity:.5">{{ $t("Bo'sh") }}</em>
          </template>
        </v-select>

        <button
          v-if="modelFilter || packageTypeFilter || filter"
          class="reset-btn"
          @click="resetFilters"
          :title="$t('Filterlarni tozalash')"
        >
          <b-icon icon="x-circle"></b-icon>
        </button>

        <button class="refresh-btn" @click="Refresh()" title="Yangilash">
          <b-icon icon="arrow-repeat"></b-icon>
        </button>
        <button class="add-btn" @click="$router.push('/paket/form')">
          <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}
        </button>
        <top></top>
      </div>
    </div>

    <!-- JADVAL -->
    <div class="table-card">
      <div class="table-wrapper">
        <table class="custom-table">
          <thead>
            <tr>
              <th style="width:50px">№</th>
              <th style="width:56px">{{ $t("Rasm") }}</th>
              <th>{{ $t("Paket Nomi") }}</th>
              <th>{{ $t("Model") }}</th>
              <th>{{ $t("Turi") }}</th>
              <th class="text-right">{{ $t("Chakana") }}</th>
              <th class="text-right">{{ $t("Optom") }}</th>
              <th style="width:90px; text-align:center">{{ $t("Amallar") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedItems" :key="item.id">
              <td><span class="id-badge">{{ (currentPage - 1) * $store.state.countindex + index + 1 }}</span></td>
              <td>
                <img v-if="item.image" :src="getImageUrl(item.image)" class="pkg-thumb" alt="">
                <div v-else class="pkg-thumb-empty">
                  <b-icon icon="image"></b-icon>
                </div>
              </td>
              <td class="fw-600">{{ item.name }}</td>
              <td>
                <span v-if="item.model" class="tag grey">{{ item.model.name }}</span>
                <span v-else class="text-muted">—</span>
              </td>
              <td>
                <span v-if="item.package_type" class="tag purple">{{ item.package_type.name }}</span>
                <span v-else class="text-muted">—</span>
              </td>
              <td class="text-right">
                <div class="price-cell">
                  <span class="price-main">{{ formatMoney(grandTotalChakana(item)) }}</span>
                  <small class="price-detail">
                    ish: {{ formatShort(item.labor_price_chakana) }} | pred: {{ formatShort(item.redo_price_chakana) }} | mat: {{ formatShort(materialTotalChakana(item)) }}
                  </small>
                </div>
              </td>
              <td class="text-right">
                <div class="price-cell">
                  <span class="price-main">{{ formatMoney(grandTotalOptom(item)) }}</span>
                  <small class="price-detail">
                    ish: {{ formatShort(item.labor_price_optom) }} | pred: {{ formatShort(item.redo_price_optom) }} | mat: {{ formatShort(materialTotalOptom(item)) }}
                  </small>
                </div>
              </td>
              <td>
                <div class="actions">
                  <button class="icon-btn edit" @click="$router.push('/paket/edit/' + item.id)">
                    <b-icon icon="pencil"></b-icon>
                  </button>
                  <button class="icon-btn del" @click="ConfirmTrash(item.id)">
                    <b-icon icon="trash"></b-icon>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="filteredItems.length === 0">
              <td colspan="8" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINATSIYA -->
      <div class="table-footer">
        <span class="info">{{ totalRows }} {{ $t('ta') }} / {{ Math.min(currentPage * $store.state.countindex, totalRows) }} {{ $t('tasi') }}</span>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="$store.state.countindex"
          align="right" size="sm" class="my-0 custom-pagination"></b-pagination>
      </div>
    </div>

    <!-- O'CHIRISH MODALI -->
    <b-modal id="modal-delete" hide-footer centered no-stacking no-close-on-backdrop>
      <div class="text-center p-3">
        <div class="warning-icon mb-3">!</div>
        <h4 class="fw-bold mb-2">{{ $t("O'chirishni tasdiqlaysizmi?") }}</h4>
        <p class="text-muted mb-3">{{ $t("Ushbu amalni ortga qaytarib bo'lmaydi.") }}</p>
        <div class="modal-footer-btns">
          <button class="m-btn cancel-btn" @click="$bvModal.hide('modal-delete')">{{ $t("YO'Q") }}</button>
          <button class="m-btn del-btn" @click="DeleteData">{{ $t("HA, O'CHIRILSIN") }}</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import Top from "../../pages/Layout/Top.vue";

export default {
  components: { Top },
  data() {
    return {
      items: [],
      filter: "",
      currentPage: 1,
      itemToDeleteId: null,
      // Filterlar uchun manbalar
      modelList: [],
      packageTypes: [],
      modelFilter: null,
      packageTypeFilter: null
    };
  },
  computed: {
    filteredItems() {
      let list = this.items;

      // Model bo'yicha filter
      if (this.modelFilter) {
        list = list.filter(item => item.model_id === this.modelFilter
          || (item.model && item.model.id === this.modelFilter));
      }

      // Paket turi bo'yicha filter
      if (this.packageTypeFilter) {
        list = list.filter(item => item.package_type_id === this.packageTypeFilter
          || (item.package_type && item.package_type.id === this.packageTypeFilter));
      }

      // Qidiruv bo'yicha filter (nom va model nomi orqali)
      if (this.filter) {
        const s = this.filter.toLowerCase();
        list = list.filter(item =>
          (item.name || '').toLowerCase().includes(s) ||
          (item.model && (item.model.name || '').toLowerCase().includes(s)) ||
          (item.package_type && (item.package_type.name || '').toLowerCase().includes(s))
        );
      }

      return list;
    },
    totalRows() {
      return this.filteredItems.length;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.$store.state.countindex;
      return this.filteredItems.slice(start, start + this.$store.state.countindex);
    }
  },
  watch: {
    filter() { this.currentPage = 1; },
    modelFilter() { this.currentPage = 1; },
    packageTypeFilter() { this.currentPage = 1; }
  },
  created() {
    this.Refresh();
    this.loadModels();
    this.loadPackageTypes();
  },
  methods: {
    Refresh() {
      axios.get("api/v1/repair_package").then(res => {
        this.items = res.data;
      });
    },
    loadModels() {
      axios.get("api/v1/model/").then(res => {
        this.modelList = res.data || [];
      }).catch(() => { this.modelList = []; });
    },
    loadPackageTypes() {
      axios.get("api/v1/package_types").then(res => {
        this.packageTypes = res.data || [];
      }).catch(() => { this.packageTypes = []; });
    },
    resetFilters() {
      this.filter = "";
      this.modelFilter = null;
      this.packageTypeFilter = null;
      this.currentPage = 1;
    },
    getImageUrl(image) {
      return axios.defaults.baseURL + '/api/v1/uploads/' + image;
    },
    materialTotalChakana(item) {
      if (!item.items || !item.items.length) return 0;
      return item.items.reduce((sum, i) => sum + (Number(i.price_chakana || 0) * Number(i.quantity || 0)), 0);
    },
    materialTotalOptom(item) {
      if (!item.items || !item.items.length) return 0;
      return item.items.reduce((sum, i) => sum + (Number(i.price_optom || 0) * Number(i.quantity || 0)), 0);
    },
    grandTotalChakana(item) {
      return this.materialTotalChakana(item) + Number(item.labor_price_chakana || 0) + Number(item.redo_price_chakana || 0);
    },
    grandTotalOptom(item) {
      return this.materialTotalOptom(item) + Number(item.labor_price_optom || 0) + Number(item.redo_price_optom || 0);
    },
    formatMoney(v) {
      if (!v) return "0";
      return Number(v).toLocaleString().replace(/,/g, ' ');
    },
    formatShort(v) {
      if (!v) return "0";
      return Number(v).toLocaleString().replace(/,/g, ' ');
    },
    ConfirmTrash(id) {
      this.itemToDeleteId = id;
      this.$bvModal.show('modal-delete');
    },
    DeleteData() {
      if (!this.itemToDeleteId) return;
      axios.delete("api/v1/repair_package/" + this.itemToDeleteId)
        .then(() => {
          this.$bvModal.hide('modal-delete');
          this.Refresh();
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.g-page {
  padding: 16px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 22px;
  margin: 0;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

@media (max-width: 1200px) {
  .header-vselect { min-width: 150px; }
}
@media (max-width: 900px) {
  .header-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .header-actions {
    justify-content: flex-start;
  }
  .header-vselect { min-width: 140px; flex: 1 1 140px; }
  .modern-search { width: 100%; flex: 1 1 100%; }
}
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.search-icon {
  position: absolute;
  left: 10px;
  color: #94a3b8;
  font-size: 13px;
}
.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 7px 12px 7px 30px;
  border-radius: 10px;
  width: 220px;
  outline: none;
  transition: 0.2s;
  font-size: 13px;
}
.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.08);
}
.add-btn {
  background: linear-gradient(135deg, #a142f4, #8b2cf5);
  color: white;
  border: none;
  height: 34px;
  padding: 0 16px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 3px 10px rgba(161, 66, 244, 0.25);
}
.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Header filter dropdownlar */
.header-vselect {
  min-width: 180px;
  font-size: 13px;
}
.header-vselect ::v-deep .vs__dropdown-toggle {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 2px 4px;
  min-height: 34px;
}
.header-vselect ::v-deep .vs__search,
.header-vselect ::v-deep .vs__search:focus {
  font-size: 13px;
  padding: 4px 6px;
  margin: 0;
}
.header-vselect ::v-deep .vs__selected {
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
}
.header-vselect ::v-deep .vs--open .vs__dropdown-toggle {
  border-color: #a142f4;
  box-shadow: 0 0 0 3px rgba(161, 66, 244, 0.08);
}
.header-vselect ::v-deep .vs__clear {
  fill: #94a3b8;
}

/* Reset filter tugmasi */
.reset-btn {
  background: #fff1f2;
  border: 1px solid #fecdd3;
  color: #e11d48;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.reset-btn:hover {
  background: #e11d48;
  color: white;
  border-color: #e11d48;
}

/* Table */
.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}
.custom-table {
  width: 100%;
  border-collapse: collapse;
}
.custom-table th {
  position: sticky;
  top: 0;
  background: #fafbfc;
  z-index: 5;
  padding: 10px 12px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
  white-space: nowrap;
}
.custom-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 13px;
}
.custom-table tbody tr:hover {
  background: #fafbfe;
}

/* Cells */
.id-badge {
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 6px;
  font-family: monospace;
  font-weight: 700;
  font-size: 12px;
  color: #64748b;
}
.fw-600 { font-weight: 600; }
.text-right { text-align: right; }

.tag {
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}
.tag.grey { background: #f1f5f9; color: #475569; }
.tag.purple { background: #f5f3ff; color: #a142f4; }

/* Price */
.price-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
}
.price-main {
  font-weight: 800;
  font-size: 13px;
  color: #16a34a;
}
.price-detail {
  color: #94a3b8;
  font-size: 10px;
  white-space: nowrap;
}

/* Image */
.pkg-thumb {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #f1f5f9;
}
.pkg-thumb-empty {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px dashed #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
  font-size: 14px;
}

/* Actions */
.actions {
  display: flex;
  gap: 6px;
  justify-content: center;
}
.icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 13px;
}
.edit { background: #eff6ff; color: #2563eb; }
.del { background: #fff1f2; color: #e11d48; }

/* Footer */
.table-footer {
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  font-size: 12px;
  color: #94a3b8;
}
.empty-row {
  text-align: center;
  padding: 40px;
  color: #cbd5e1;
}

/* Modal */
.warning-icon {
  width: 50px;
  height: 50px;
  background: #fee2e2;
  color: #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto;
}
.modal-footer-btns {
  display: flex;
  gap: 10px;
}
.m-btn {
  flex: 1;
  padding: 10px;
  border-radius: 12px;
  border: none;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}
.cancel-btn { background: #f1f5f9; color: #64748b; }
.del-btn { background: #ef4444; color: white; }
</style>
